import PropTypes from 'prop-types';
import { useState } from 'react';

import Accordion from '@/components/common/Accordion';

const CollapsableDetails = ({ label, details }) => {
  const [isOpen, setIsOpen] = useState(false);

  return details ? (
    <div className="collapsable-details">
      <Accordion label={label} open={isOpen} onClick={() => setIsOpen(!isOpen)} labelClassName="label">
        {details.map((detail) => (
          <div key={detail.label} className="item-row">
            <div className="item-key">{detail.label}</div>
            <div className={`item-value ${detail.className}`}>{detail.value}</div>
          </div>
        ))}
      </Accordion>
    </div>
  ) : (
    <></>
  );
};

CollapsableDetails.propTypes = {
  label: PropTypes.string.isRequired,
  details: PropTypes.array
};

export default CollapsableDetails;
